import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

// Custom hook/component
// Queries project images via graphql
// And return fluid images along with descriptions and filters

const useImageQuery = () => {
  const imageData = useStaticQuery(graphql`
    query {
      eCard: file(relativePath: { eq: "e-card.png" }) {
        childImageSharp {
          fluid(maxWidth: 560, sizes: "(max-width: 560px) 100vw, 560px") {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      markdownPreview: file(relativePath: { eq: "markdown-preview.png" }) {
        childImageSharp {
          fluid(maxWidth: 560, sizes: "(max-width: 560px) 100vw, 560px") {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      weather: file(relativePath: { eq: "weather.png" }) {
        childImageSharp {
          fluid(maxWidth: 560, sizes: "(max-width: 560px) 100vw, 560px") {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      wordGame: file(relativePath: { eq: "wordgame.png" }) {
        childImageSharp {
          fluid(maxWidth: 560, sizes: "(max-width: 560px) 100vw, 560px") {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return [
    {
      id: 1,
      type: ['react', 'node'],
      image: imageData.eCard.childImageSharp.fluid,
      desc: (
        <p>
          A multiplayer card game. Made using React with Redux for state
          management, and uses Websockets for real-time interaction, and
          Firebase for auth. You can check it out{' '}
          <a
            href="https://e-card.netlify.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </p>
      ),
    },
    {
      id: 2,
      type: ['js'],
      image: imageData.weather.childImageSharp.fluid,
      desc: (
        <p>
          A simple JS app to check weather using OpenWeather API. I made this to
          practice using APIs. You can check it out{' '}
          <a
            href="https://pragunsaini.github.io/WeatherChecker"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </p>
      ),
    },
    {
      id: 3,
      type: ['js'],
      image: imageData.wordGame.childImageSharp.fluid,
      desc: (
        <p>
          A typing game made using pure JS. You can check it out{' '}
          <a
            href="https://pragunsaini.github.io/SimpleWordGame/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </p>
      ),
    },
    {
      id: 4,
      type: ['react'],
      image: imageData.markdownPreview.childImageSharp.fluid,
      desc: (
        <p>
          React app to live preview markdown. You can check it out{' '}
          <a
            href="https://pragunsaini.github.io/MarkDownPreview/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </p>
      ),
    },
  ]
}

export default useImageQuery
